import LottieModule from '../../elements/animatedIllustration/lottieModule.util.js';

const {registerModule} = window;

class FullImage extends LottieModule {}

registerModule('FullImage', FullImage);
